import {
  SimpleShowLayout,
  Show,
  TextField,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Labeled,
} from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowRooms = () => {
  return (
    <Show
      title="Детайли за зала"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Етаж">
              <TextField source="floor" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Номер">
              <TextField source="number" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Код">
              <TextField source="code" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Тип">
              <ReferenceField
                source="typeId"
                reference={administrationRequests.getRoomTypesSelect()}
              >
                <TextField
                  source="name"
                  label="Тип"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Катедри">
              <ReferenceArrayField
                source="departmentIds"
                reference={administrationRequests.getDepartmentsSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Капацитет за лекции/упражнения">
              <TextField source="capacityClasses" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Капацитет за изпит">
              <TextField source="capacityExam" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Техническо оборудване">
              <ReferenceArrayField
                source="technicalEquipmentIds"
                reference={administrationRequests.getTechnicalEquipmentTypesSelect()}
              >
                <SingleFieldList>
                  <TextField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Дисциплина">
              <ReferenceArrayField
                source="disciplineIds"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <SingleFieldList>
                  <TextField
                    label="Дисциплина"
                    source="name"
                  />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Тип занятия">
              <ReferenceArrayField
                source="classTypeIds"
                reference={administrationRequests.getRoomClassTypesSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Сграда">
              <ReferenceField
                source="buildingId"
                reference={administrationRequests.getBuildingsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Структурни единици">
              <ReferenceArrayField
                source="structuralUnitIds"
                reference={administrationRequests.getStructuralUnitsSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowRooms;
